import React from 'react';
import PropType from 'prop-types';
import { Badge, Button } from '@mui/material';
import { badgeStyle, viewBtnStyle } from 'src/styles/NewLeadTableRowStyle';

// Conceptual frame: a TREATMENT_STARTED row is "treatment in progress" (a long
// phase whose checklist is the ongoing/setup work), NOT a prompt to close.
// Label = "Treatment in progress" (+ "· {N}" open-task count when available).
// CLOSED rows keep "View details". Clicking a TREATMENT_STARTED row still opens
// the hub via handleCompleteTreatment.
//
// openTaskCount: optional. The treatment-started table does NOT currently load a
// per-row open-task COUNT (the row only carries checklist_state = "in_progress"
// | "complete" — a boolean, not a number; see report). When a count source is
// wired, pass it here and it renders as "· {N}". Until then it stays null and
// the label shows "Treatment in progress" with no count.
const CustomCompleteTreatmentBtn = ({ params, viewDetailBtn, handleCompleteTreatment, openTaskCount }) => {
    const isStarted = params.row.status === 'TREATMENT_STARTED';

    // TREATMENT_STARTED → open the wrap-up hub via handleCompleteTreatment when
    // provided (falls back to viewDetailBtn for backward-compat / if absent).
    const onClick = () => {
        if (isStarted && handleCompleteTreatment) {
            handleCompleteTreatment(params.row);
            return;
        }
        viewDetailBtn(params.row.lead_id, params.row.status, params.row);
    };

    let label;
    if (params.row.status === 'CLOSED') {
        label = 'View details';
    } else if (isStarted) {
        // Append the open-task count only when a positive number is provided.
        label = openTaskCount > 0 ? `Treatment in progress · ${openTaskCount}` : 'Treatment in progress';
    } else {
        label = 'Complete treatment';
    }

    return (
        <Button
            variant="contained"
            color='primary'
            onClick={onClick}
            sx={viewBtnStyle(params.row?.status)}
        >
            {isStarted ? (
                // In-progress button: no contacted-count badge (the stray "0" was noise).
                label
            ) : (
                <Badge badgeContent={[params.row?.lead_treatments__lead_contacted_counts__count]} color="primary"
                    sx={badgeStyle(params.row.status, params.row?.lead_treatments__lead_contacted_counts__count)}
                >
                    {label}
                </Badge>
            )}
        </Button>
    );
};

export default CustomCompleteTreatmentBtn;

CustomCompleteTreatmentBtn.propTypes = {
    params: PropType.any,
    viewDetailBtn: PropType.func,
    handleCompleteTreatment: PropType.func,
    openTaskCount: PropType.number,
};

CustomCompleteTreatmentBtn.defaultProps = {
    openTaskCount: null,
};
